import { GENERIC_UI_CONFIG } from "~/modules/dtwin/constants";
import type { DynamicUICommon } from "~/modules/dtwin/models/DynamicUICommon.interface";
import { i18n } from "~/plugins/i18n";

export function useGetGenericUiConfig() {
  function translateColumns<T extends DynamicUICommon>(
    columns: T[],
    t: (key: string) => string,
  ) {
    return columns.map((column) => {
      const translatedColumn = { ...column };
      if (column.label) {
        translatedColumn.label = t(column.label);
      }
      if (column.formattingProcess?.options) {
        translatedColumn.formattingProcess = {
          ...column.formattingProcess,
          options: column.formattingProcess.options.map((option) => {
            const translatedOption = { ...option };
            if (option.label) {
              translatedOption.label = t(option.label);
            }
            return translatedOption;
          }),
        };
      }
      return translatedColumn;
    });
  }

  function getGenericUiConfig() {
    const { t } = i18n.global;

    return {
      ...GENERIC_UI_CONFIG,
      list: {
        ...GENERIC_UI_CONFIG.list,
        columns: translateColumns(GENERIC_UI_CONFIG.list.columns, t),
      },
      details: {
        ...GENERIC_UI_CONFIG.details,
        description: Array.isArray(GENERIC_UI_CONFIG.details.description)
          ? translateColumns(GENERIC_UI_CONFIG.details.description, t)
          : GENERIC_UI_CONFIG.details.description,
        ...(GENERIC_UI_CONFIG.details.firmware && {
          firmware: Array.isArray(GENERIC_UI_CONFIG.details.firmware)
            ? translateColumns(GENERIC_UI_CONFIG.details.firmware, t)
            : GENERIC_UI_CONFIG.details.firmware,
        }),
        ...(GENERIC_UI_CONFIG.details.certificate && {
          certificate: Array.isArray(GENERIC_UI_CONFIG.details.certificate)
            ? translateColumns(GENERIC_UI_CONFIG.details.certificate, t)
            : GENERIC_UI_CONFIG.details.certificate,
        }),
        ...(GENERIC_UI_CONFIG.details.configuration && {
          configuration: Array.isArray(GENERIC_UI_CONFIG.details.configuration)
            ? translateColumns(GENERIC_UI_CONFIG.details.configuration, t)
            : GENERIC_UI_CONFIG.details.configuration,
        }),
      },
    };
  }

  return {
    getGenericUiConfig,
  };
}
